import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { TableAdv } from '../../../../../components';
import { mapTableRows } from '../../../../../utils';
import { useEffect } from 'react';
import { formatWords2 } from '../../../../../utils/stringUtils';
import { clearClientSubmissions, fetchClientSubmissionsStart } from '../../../../../redux/slices/bdmjobs/bdmjobsSlice';
import { totalCountStart } from '../../../../../redux/slices/totalCount/totalCountSlice';
import { usePagination } from '../../../../../hooks';
import { Link } from 'react-router-dom';
import { convertFromUTC } from '../../../../../utils/dateUtils';

//this full tab created  by yashwanth

const JobApplied = ({ data }) => {
    const { value } = useSelector((state) => state?.totalCount);
    const totalCount = value?.submissionCount?.data || 0;

    const clientData = useSelector(
        (state) => state.bdmJobs.clientsubmissions.data
    );
    const { page, limit, setPage, handleLimitChange } = usePagination(
        10,
        (newPage, newLimit) => { }
    );
const statusOptions = [
  { label: "shortlisted", value: 1 },
  { label: "pipeline", value: 2 },
  { label: "Submitted", value: 3 },
  { label: "Review call by BDM", value: 4 },
  { label: "BDM Interview", value: 5 },
  { label: "Disqualified", value: 6 },
  { label: "Hold", value: 7 },
  { label: "Withdrawn", value: 8 },
  { label: "Waiting for Writeup", value: 9 },
  { label: "Submitted to Client", value: 10 },
  { label: "Submitted To Vendor", value: 11 },
  { label: "Shortlisted for Interview", value: 12 },
  { label: "Interview Confirmation", value: 13 },
  { label: "Interview Scheduled", value: 14 },
  { label: "L1 Interview Scheduled", value: 15 },
  { label: "L2 Interview Scheduled", value: 16 },
  { label: "L3 Interview Scheduled", value: 17 },
  { label: "L1 Interview Selected", value: 18 },
  { label: "L2 Interview Selected", value: 19 },
  { label: "L3 Interview Selected", value: 20 },
  { label: "L1 Interview Rejected", value: 21 },
  { label: "L2 Interview Rejected", value: 22 },
  { label: "L3 Interview Rejected", value: 23 },
  { label: "L1 Interview Re-Scheduled", value: 24 },
  { label: "L2 Interview Re-Scheduled", value: 25 },
  { label: "L3 Interview Re-Scheduled", value: 26 },
  { label: "L1 Interview Feedback Pending", value: 27 },
  { label: "L2 Interview Feedback Pending", value: 28 },
  { label: "L3 Interview Feedback Pending", value: 29 },
  { label: "Rejected By Client", value: 30 },
  { label: "Selected but no response from the client", value: 31 },
  { label: "Rejected after Client Selection", value: 32 },
  { label: "Submitted to End Client", value: 33 },
  { label: "Vendor Interview", value: 34 },
  { label: "Vendor Interview Reject", value: 35 },
  { label: "Client Interview", value: 36 },
  { label: "Client Interview Select", value: 37 },
  { label: "Client Interview Reject", value: 38 },
  { label: "Client Interview Completed", value: 39 },
  { label: "End Client Interview", value: 40 },
  { label: "End Client Interview Completed", value: 41 },
  { label: "Selected By Vendor", value: 42 },
  { label: "Selected By Client", value: 43 },
  { label: "Selected By End Client", value: 44 },
  { label: "Rejected By Vendor", value: 45 },
  { label: "Rejected by End Client", value: 46 },
  { label: "Disqualified By Vendor", value: 47 },
  { label: "Disqualified By Client", value: 48 },
  { label: "Disqualified by End Client", value: 49 },
  { label: "Hold By Vendor", value: 50 },
  { label: "Hold By Client", value: 51 },
  { label: "Hold by End Client", value: 52 },
  { label: "Drop", value: 53 },
  { label: "Position on Hold", value: 54 },
  { label: "PW Interview Proposed By Buyer", value: 55 },
  { label: "PW Interview Proposed By Supplier", value: 56 },
  { label: "PW Interview Failed", value: 57 },
  { label: "PW Interview Cancelled", value: 58 },
  { label: "PW Interview Success", value: 59 },
  { label: "Assignment Contract Sent", value: 60 },
  { label: "Assignment Contract Verified", value: 61 },
  { label: "Assignment Contract Rejected", value: 62 },
  { label: "Confirmed", value: 63 },
  { label: "Position Filled", value: 64 },
  { label: "Backout", value: 65 },
  { label: "Not Joined", value: 66 },
  { label: "BGV Failed", value: 67 },
  { label: "Got Pay Rate Confirmation", value: 68 },
  { label: "Offer Withdrawn", value: 69 },
  { label: "Negotiation", value: 70 },
  { label: "Start", value: 71 },
  { label: "Offer Sent", value: 72 },
  { label: "Offer Accepted", value: 73 },
  { label: "Offer Rejected", value: 74 },
  { label: "Hold with Client", value: 75 },
  { label: "Hold with Vendor", value: 76 },
  { label: "Rejected Internally", value: 77 },
];
    const statusMap = statusOptions.reduce((acc, s) => {
        acc[s.value] = s.label;
        return acc;
    }, {});
   
    const columns = [
        {
            key: "id",
            label: "S.No",
        },
        {
            key: "code",
            label: "Job Code",
            render: (row) => (

                <Link
                    to={`/ats/jobs/job-details`}
                    className="text-info"
                    state={{ uiid: row?.jobPostId, applicantId: data?.uiid }}
                    onClick={() => {
                        sessionStorage.setItem("selectedJobUiid", row?.jobPostId);
                        sessionStorage.setItem("prevJobsPage", window.location.pathname + window.location.search);
                    }}
                >
                    {row?.code}
                </Link>

            ),
        },

        { key: "companyName", label: "Company Name" },
        {
            key: "submittedBy",
            label: "Submitted By",
        },
        {
            key: "submittedOn",
            label: "Submitted On",
        },
        {
            key: "status",
            label: "Status",
            render: (row) => (
                <div >
                    {row.status}
                </div>
            )
        },
    ];
    const clientdata = clientData || [];
    const rows = clientdata.map((item, index) => {
        const latestStatusValue = item?.currentStatus || item?.statusHistory?.[item.statusHistory.length - 1]?.status;
        return {
            id: index + 1,
            uiid: item?.uiid,
            jobPostId: item?.jobPostId?.uiid || "",
            code: item?.jobPostId?.jobInfo?.jobCode || "",
            companyName: formatWords2(item?.jobPostId?.companyId?.name || "N/A"),
            submittedBy: formatWords2(item?.addedBy?.firstName || ""),
            submittedOn: item?.addedOn ? new Date(convertFromUTC(item.addedOn))
                .toLocaleDateString("en-GB")
                : "-",
            status: statusMap[latestStatusValue] || "-",
        };
    });
    const mappedRows = mapTableRows(rows, columns);
    const dispatch = useDispatch();
      useEffect(() => {
        // Clear previous data before fetching new
        dispatch(clearClientSubmissions());
    
        // ... rest of fetch logic is in other effect
      }, [dispatch, data?.uiid]);

    const fetchAllJobs = () => {
        dispatch(
            totalCountStart({
                collection: "submissions",
                coll: "Submission",
                tname: "submissionCount",
                app: "ats",
                filters: { "candidateId": { type: "NONE", value: data?.uiid } },

            })
        );

        dispatch(
            fetchClientSubmissionsStart({
                coll: "Submission",
                lim: limit,
                pg: page,
                ret: "uiid jobPostId addedBy addedOn currentStatus statusHistory",
                ref: "JobPosting",
                fil: { "candidateId": { type: "NONE", value: data?.uiid } },
                extret: "uiid firstName lastName",
                sort: JSON.stringify({ addedOn: -1 })
            })
        );
    };

    useEffect(() => {
        fetchAllJobs();
    }, [dispatch, page, limit, data?.uiid]);

    return (
        <>
            <TableAdv
                columns={columns}
                rows={mappedRows}
                limit={limit}
                page={page}
                serverPagination
                onPaginationChange={setPage}
                onLimitChange={handleLimitChange}
                totalCount={totalCount}
            />
        </>
    )
}

export default JobApplied